import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

export default function Perfil() {
  const { usuario, carregarPerfil, ehPremium } = useAuth();
  const [form, setForm] = useState({
    nome: usuario?.nome||'', whatsapp: usuario?.whatsapp||'',
    cidade: usuario?.cidade||'', estado: usuario?.estado||'',
  });
  const [senhaForm, setSenhaForm] = useState({ senha_atual:'', nova_senha:'', confirma:'' });
  const [msgPerfil, setMsgPerfil] = useState('');
  const [msgSenha,  setMsgSenha]  = useState('');

  const upd  = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  const updS = e => setSenhaForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const salvar = async e => {
    e.preventDefault();
    try { await api.patch('/usuarios/perfil', form); await carregarPerfil(); setMsgPerfil('sucesso'); }
    catch { setMsgPerfil('erro'); }
  };

  const alterarSenha = async e => {
    e.preventDefault();
    if (senhaForm.nova_senha !== senhaForm.confirma) return setMsgSenha('As senhas não coincidem.');
    try {
      await api.patch('/usuarios/senha', { senha_atual: senhaForm.senha_atual, nova_senha: senhaForm.nova_senha });
      setSenhaForm({ senha_atual:'', nova_senha:'', confirma:'' });
      setMsgSenha('sucesso');
    } catch (err) { setMsgSenha(err.response?.data?.error || 'Erro ao alterar.'); }
  };

  const cardStyle = { padding:'32px 36px', marginBottom:20 };
  const h2Style   = { fontFamily:"'Playfair Display',serif", fontSize:20, marginBottom:22 };

  return (
    <>
      <Navbar />
      <div style={{ background:'var(--cream)', minHeight:'calc(100vh - 112px)', padding:'56px 0' }}>
        <div className="container" style={{ maxWidth:640 }}>
          <div className="page-header">
            <div className="eyebrow">Minha conta</div>
            <h1 className="section-title">Perfil</h1>
            <div className="gold-rule" />
          </div>

          {/* Meus anuncios — somente para premium */}
          {ehPremium() && (
            <div className="card" style={{ ...cardStyle, display:'flex', justifyContent:'space-between', alignItems:'center', gap:20 }}>
              <div>
                <h2 style={{ ...h2Style, marginBottom:6 }}>Meus anúncios</h2>
                <p style={{ color:'var(--ink-muted)', fontSize:14, lineHeight:1.6 }}>
                  Visualize, edite ou encerre os veículos que você anunciou na plataforma Heritage.
                </p>
              </div>
              <Link to="/meus-anuncios" className="btn btn-primary btn-sm" style={{ flexShrink:0 }}>
                Ver anúncios
              </Link>
            </div>
          )}

          {/* Dados pessoais */}
          <div className="card" style={cardStyle}>
            <h2 style={h2Style}>Dados pessoais</h2>
            {msgPerfil === 'sucesso' && <div className="alert alert-success">Perfil atualizado com sucesso.</div>}
            {msgPerfil === 'erro'    && <div className="alert alert-danger">Erro ao salvar. Tente novamente.</div>}
            <form onSubmit={salvar}>
              <div className="form-group"><label>Nome</label><input name="nome" value={form.nome} onChange={upd} /></div>
              <div className="form-group"><label>WhatsApp</label><input name="whatsapp" value={form.whatsapp} onChange={upd} /></div>
              <div className="form-row">
                <div className="form-group"><label>Cidade</label><input name="cidade" value={form.cidade} onChange={upd} /></div>
                <div className="form-group"><label>Estado</label><input name="estado" value={form.estado} onChange={upd} maxLength={2} /></div>
              </div>
              <div className="form-group">
                <label>E-mail</label>
                <input value={usuario?.email} disabled style={{ opacity:.55, cursor:'not-allowed' }} />
              </div>
              <button type="submit" className="btn btn-primary btn-sm">Salvar alterações</button>
            </form>
          </div>

          {/* Senha */}
          <div className="card" style={cardStyle}>
            <h2 style={h2Style}>Alterar senha</h2>
            {msgSenha === 'sucesso' && <div className="alert alert-success">Senha alterada com sucesso.</div>}
            {msgSenha && msgSenha !== 'sucesso' && <div className="alert alert-danger">{msgSenha}</div>}
            <form onSubmit={alterarSenha}>
              <div className="form-group"><label>Senha atual</label><input name="senha_atual" type="password" value={senhaForm.senha_atual} onChange={updS} required /></div>
              <div className="form-group"><label>Nova senha</label><input name="nova_senha" type="password" value={senhaForm.nova_senha} onChange={updS} required minLength={6} /></div>
              <div className="form-group"><label>Confirmar nova senha</label><input name="confirma" type="password" value={senhaForm.confirma} onChange={updS} required /></div>
              <button type="submit" className="btn btn-primary btn-sm">Alterar senha</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
